import React from 'react';
import Header from './Header';
import { Outlet } from 'react-router-dom';
import CssBaseline from '@mui/material/CssBaseline/CssBaseline';
import { useAppBackground } from '../../lib/hooks/app-hooks';
import { ConfigurationActionTypes } from '../../lib/contexts/ConfigurationContext/actions';
import { useConfigurationDispatch } from '../../lib/contexts/ConfigurationContext/ConfigurationContext';

/**
 * Layout of the DocApp.
 */
const Layout = () => {
    useAppBackground((t) => t.palette.appBackground.main);

    const dispatch = useConfigurationDispatch();

    const ref = React.useRef<HTMLDivElement>();

    React.useEffect(() => {
        dispatch({
            type: ConfigurationActionTypes.SetHeaderOffsetHeight,
            payload: (ref.current?.offsetHeight as number) + 1
        });
    }, [dispatch]);

    return (
        <CssBaseline>
            <Header refObj={ref} />
            <Outlet />
        </CssBaseline>
    );
};

export default Layout;
